export default theme => ({

  paper: {
    height: '100%',
    width: '100%',
    display: 'flex',
    'justify-content': 'center'
  },

  container: {
    height: `calc(100% - ${theme.spacing.unit * 4}px)`,
    width: '100%',
    padding: theme.spacing.unit * 2,
    maxWidth: '750px',
    marginRight: theme.spacing.unit * 34,

    [theme.breakpoints.up('lg')]: {
      marginLeft: theme.spacing.unit * 34
    }
  }

})



// WEBPACK FOOTER //
// ./src/styles/pages/configurator.js